import { render } from "./AssortmentPage.vue?vue&type=template&id=3f47a31d&scoped=true"
import script from "./AssortmentPage.vue?vue&type=script&lang=js"
export * from "./AssortmentPage.vue?vue&type=script&lang=js"

import "./AssortmentPage.vue?vue&type=style&index=0&id=3f47a31d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f47a31d"]])

export default __exports__